/**
 * GateExportBar — botões "Baixar .md" e "Baixar PDF" para as telas de gate.
 *
 * Estilo alinhado ao dos botões secundários já usados nas telas de gate
 * (transparente, borda cyber, texto pequeno). Não faz nenhuma chamada de
 * API: recebe o objeto `gate` já montado pela tela (ver gateExport.js).
 */
import { C } from '@/theme/palette';
import { useState } from 'react';
import { downloadGateMarkdown, printGatePdf } from './gateExport';

const CYBER = C.cyber;
const HOT = C.hot;

const btnStyle = {
  cursor: 'pointer',
  background: 'transparent',
  color: CYBER,
  border: `1px solid ${CYBER}55`,
  borderRadius: 7,
  padding: '5px 11px',
  fontSize: 12,
  fontWeight: 600,
  whiteSpace: 'nowrap',
};

export function GateExportBar({ gate, style }) {
  const [error, setError] = useState('');

  const onMarkdown = () => {
    setError('');
    try {
      downloadGateMarkdown(gate);
    } catch {
      setError('Não foi possível gerar o .md deste gate.');
    }
  };

  const onPdf = () => {
    setError('');
    const ok = printGatePdf(gate);
    if (!ok) setError('Pop-up bloqueado pelo navegador — permita pop-ups para baixar o PDF.');
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap', ...style }}>
      <button type="button" onClick={onMarkdown} style={btnStyle} aria-label="Baixar este gate em Markdown">
        ⇩ Baixar .md
      </button>
      <button type="button" onClick={onPdf} style={btnStyle} aria-label="Baixar este gate em PDF">
        ⇩ Baixar PDF
      </button>
      {error && (
        <span role="alert" style={{ fontSize: 11.5, color: HOT }}>{error}</span>
      )}
    </div>
  );
}
